import { AssetMaintenanceService } from './asset-maintenance.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ASSET_MAINTENANCE_TYPE, AssetMaintenance } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class AssetMaintenanceResolverBase implements Resolve<AssetMaintenance> {

  constructor(protected service: AssetMaintenanceService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AssetMaintenance> {
    const key: number = ASSET_MAINTENANCE_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



